// This file handles API interactions for finance features (savings, budgets, resources).

import api from './axiosConfig';

// --- SAVINGS ---

// Fetch all savings goals
export const fetchSavingsGoals = async () => {
    try {
        const response = await api.get('/finance/savings');
        return response.data;
    } catch (error) {
        console.error('Error fetching savings goals:', error);
        throw error;
    }
};

// Create a new savings goal
export const createSavingsGoal = async (goalData) => {
    try {
        const response = await api.post('/finance/savings', goalData);
        return response.data;
    } catch (error) {
        console.error('Error creating savings goal:', error);
        throw error;
    }
};

// Deposit into a savings goal
export const depositToSavings = async (goalId, amount, phone_number) => {
    try {
        const response = await api.post(`/finance/savings/${goalId}/deposit`, { amount, phone_number });
        return response.data;
    } catch (error) {
        console.error('Error depositing to savings:', error);
        throw error;
    }
};

// Withdraw from a savings goal
export const withdrawFromSavings = async (goalId, amount) => {
    try {
        const response = await api.post(`/finance/savings/${goalId}/withdraw`, { amount });
        return response.data;
    } catch (error) {
        console.error('Error withdrawing from savings:', error);
        throw error;
    }
};

// --- BUDGETS ---

// Fetch all budgets
export const fetchBudgets = async () => {
    try {
        const response = await api.get('/finance/budgets');
        return response.data;
    } catch (error) {
        console.error('Error fetching budgets:', error);
        throw error;
    }
};

// Create a new budget
export const createBudget = async (budgetData) => {
    try {
        const response = await api.post('/finance/budgets', budgetData);
        return response.data;
    } catch (error) {
        console.error('Error creating budget:', error);
        throw error;
    }
};

// --- RESOURCES ---

// Fetch financial literacy resources
export const fetchFinancialResources = async () => {
    try {
        const response = await api.get('/financial-resources');
        return response.data;
    } catch (error) {
        throw new Error('Error fetching financial resources: ' + error.message);
    }
};

// Fetch a specific financial resource by ID
export const fetchFinancialResourceById = async (id) => {
    try {
        const response = await api.get(`/financial-resources/${id}`);
        return response.data;
    } catch (error) {
        throw new Error('Error fetching financial resource: ' + error.message);
    }
};

// --- SAVINGS CHALLENGES ---

// Fetch all active/upcoming savings challenges
export const fetchSavingsChallenges = async () => {
    try {
        const response = await api.get('/finance/savings-challenges');
        return response.data;
    } catch (error) {
        console.error('Error fetching savings challenges:', error);
        throw error;
    }
};

// Join a savings challenge
export const joinSavingsChallenge = async (challengeId) => {
    try {
        const response = await api.post(`/finance/savings-challenges/${challengeId}/join`);
        return response.data;
    } catch (error) {
        console.error('Error joining challenge:', error);
        throw error;
    }
};

// Deposit towards a savings challenge
export const depositToChallenge = async (challengeId, amount, phone_number) => {
    try {
        const response = await api.post(`/finance/savings-challenges/${challengeId}/deposit`, { amount, phone_number });
        return response.data;
    } catch (error) {
        console.error('Error depositing to challenge:', error);
        throw error;
    }
};

// Fetch challenge leaderboard
export const fetchChallengeLeaderboard = async (challengeId) => {
    try {
        const response = await api.get(`/finance/savings-challenges/${challengeId}/leaderboard`);
        return response.data;
    } catch (error) {
        console.error('Error fetching leaderboard:', error);
        throw error;
    }
};